import { BadgeType } from "../../../Badge/Badge.types";
import { RouletteNumber } from "../../../RouletteNumber/RouletteNumber.types";
import { CustomLogo } from "./CustomLogo/CustomLogo.types";

export type GameTileBadge = {
  label?: string;
  type: BadgeType;
  rouletteNumbers?: RouletteNumber[];
};

export type GameTileImage = {
  url: string;
  width: number;
  height?: number;
  alt?: string;
};

export type GameTileImages = {
  small?: GameTileImage;
  medium?: GameTileImage;
  large?: GameTileImage;
  alt: string;
};

export type GameTileProps = {
  isRoundGameTile?: boolean;
  background?: GameTileImages;
  logo?: GameTileImages;
  flattenedImage?: GameTileImages;
  title: string;
  badge?: GameTileBadge;
  secondaryBadge?: GameTileBadge;
  copyrightText?: string;
  customLogo?: CustomLogo;
  jackpotLogo?: string;
  backgroundColor?: string;
  columns?: number;
  isFavourite?: boolean;
  isFavouriteGamesEnabled?: boolean;
  isLoggedIn?: boolean;
  isGameWidget?: boolean;
  isXmallGameTile?: boolean;
  isGameTileRefined?: boolean;
  floatingIcon?: boolean;
  gameStudioLogo?: string;
  isPromo?: boolean;
  heartAnimationTrigger?: number;
};

export enum GameLaunchMode {
  REAL = "real",
  DEMO = "demo",
}
